/**
 * The chart title displays directly on top of the grid to
 * display contextual information
 */

import React from 'react'
import colors from 'lib/components/charts/colors'
import Match from 'lib/components/match'

import { PADDING, FONT_FAMILY_SERIF } from 'lib/components/charts/constants'

export default function Title({
  x,
  y,
  children,
  fill,
  fontSize,
  fontFamily,
  padding
}) {
  const left = x + padding
  const top = y + padding

  return (
    <Match min="medium-min">
      <text
        className="chart-show-large"
        x={left}
        y={top}
        dy={fontSize}
        fontSize={fontSize}
        fill={fill}
        fontFamily={fontFamily}
      >
        {children}
      </text>
    </Match>
  )
}

Title.defaultProps = {
  fill: colors.mediumGray,
  fontSize: 16,
  fontFamily: FONT_FAMILY_SERIF,
  padding: PADDING
}



// WEBPACK FOOTER //
// ./src/components/charts/title.js